import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";

// css
import styles from "./CompanionLoadingPopup.module.scss";

const CompanionLoadingPopup = ({ createAi, setCreateAi }) => {
  const handleCreateAi = () => setCreateAi(!createAi);

  return (
    <>
      <Modal
        show={createAi}
        className={`${styles.CompanionLoadingPopup} CompanionLoadingPopup`}
        onHide={handleCreateAi}
        backdrop="static"
        keyboard={false}
        centered
        size="md"
      >
        <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
          <div className="border-bottom pb-2 position-relative">
            <div className="text-center d-flex align-items-center justify-content-center gap-3 mb-0">
              <span className="icn">{leftIcn}</span>
              <h6 className="m-0 fw-sbold text-center">
                Creating Your Companion
              </h6>
              <span className="icn">{leftIcn}</span>
            </div>
            <Button
              onClick={handleCreateAi}
              className="border-0 p-0 position-absolute"
              variant="transparent"
              style={{ right: 10, top: 0 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 16 15"
                fill="none"
              >
                <g clipPath="url(#clip0_0_6282)">
                  <path
                    d="M1.98638 14.906C1.61862 14.9274 1.25695 14.8052 0.97762 14.565C0.426731 14.0109 0.426731 13.1159 0.97762 12.5617L13.0403 0.498994C13.6133 -0.0371562 14.5123 -0.00735193 15.0485 0.565621C15.5333 1.08376 15.5616 1.88015 15.1147 2.43132L2.98092 14.565C2.70519 14.8017 2.34932 14.9237 1.98638 14.906Z"
                    fill="#000"
                  />
                  <path
                    d="M14.0347 14.9061C13.662 14.9045 13.3047 14.7565 13.0401 14.4941L0.977383 2.4313C0.467013 1.83531 0.536401 0.938371 1.13239 0.427954C1.66433 -0.0275797 2.44884 -0.0275797 2.98073 0.427954L15.1145 12.4907C15.6873 13.027 15.7169 13.9261 15.1806 14.4989C15.1593 14.5217 15.1372 14.5437 15.1145 14.5651C14.8174 14.8234 14.4263 14.9469 14.0347 14.9061Z"
                    fill="#000"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_0_6282">
                    <rect
                      width="15"
                      height="15"
                      fill="white"
                      transform="translate(0.564453)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </Button>
          </div>

          <Row className="justify-content-center">
            <Col md="12" className="my-4">
              {/* Loading Animation */}
              <div className="text-center mb-4">
                <div className={`${styles.loadingSpinner} mx-auto mb-3`}>
                  <div className={`${styles.spinnerOuter}`}></div>
                  <div className={`${styles.spinnerInner}`}></div>
                </div>
              </div>

              {/* Progress Steps */}
              <div className="d-flex flex-column gap-3">
                <div
                  className={`${styles.progressStep} bg-white p-3 rounded border`}
                >
                  <p className="m-0 fw-sbold text-center">
                    Crafting personality traits...
                  </p>
                </div>

                <div
                  className={`${styles.progressStep} bg-white p-3 rounded border`}
                >
                  <p className="m-0 fw-sbold text-center">
                    Generating appearance...
                  </p>
                </div>

                <div
                  className={`${styles.progressStep} bg-white p-3 rounded border`}
                >
                  <p className="m-0 fw-sbold text-center">
                    Setting up emotional responses...
                  </p>
                </div>
              </div>

              {/* Progress message */}
              <div className="text-center mt-4">
                <p className="text-muted mb-2">
                  This may take a few moments. Please don't close this window.
                </p>

                {/* Pulsing dots animation */}
                <div className="d-flex justify-content-center align-items-center">
                  <div className={`${styles.dot} ${styles.dot1}`}></div>
                  <div className={`${styles.dot} ${styles.dot2}`}></div>
                  <div className={`${styles.dot} ${styles.dot3}`}></div>
                </div>
              </div>
            </Col>
          </Row>

          {/* Optional Footer - uncomment if you want action buttons */}
          {/* 
          <div className="modalFooter">
            <Row className="justify-content-center">
              <Col md="3" className="my-2">
                <Button className="d-flex align-items-center justify-content-center commonBtn borderedBtn w-100 bg-transparent themeClr fw-sbold">
                  Cancel
                </Button>
              </Col>
            </Row>
          </div>
          */}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CompanionLoadingPopup;

// Icon matching your design
const leftIcn = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2L13.41 3.41L10.83 6H20V8H10.83L13.41 10.59L12 12L7 7L12 2ZM4 18V20H20V18H4Z"
      fill="#BF4AA2"
    />
  </svg>
);
